module.exports = __webpack_public_path__ + "static/media/cross.48794497.svg";